const youtubeOptions = {
    method: 'GET',
    headers: {
      'X-RapidAPI-Key': '108fd9e93bmshad2fa223ff0ea38p18e86bjsn39dec0d3ee77',
      'X-RapidAPI-Host': 'youtube-search-and-download.p.rapidapi.com'
    }
}
  
export default youtubeOptions